/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2024 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import VaultSetupForm from './components/VaultSetupForm'
import FeaturesForm from './components/FeaturesForm'
import LicensesTable from '../LicensesTable'
import SectionContainer from '../SectionContainer'
import Styles from '../../styles.module.sass'

const ServiceTab = ({
  setVaultPricing,
  getLicensesIdsSelected,
  vaultFeature,
  getFeaturePrices,
  featuresForForm,
  featurePricing,
  vaultPricing,
  registerLicenses
}) => {
  return (
    <>
      <SectionContainer
        className="mb-xs"
      >
        <VaultSetupForm
          getVaultPricing={setVaultPricing}
          getLicensesIdsSelected={getLicensesIdsSelected}
          vaultFeature={vaultFeature}
        />
      </SectionContainer>
      <SectionContainer
        className="mb-md"
      >
        <FeaturesForm
          getFeaturePrices={getFeaturePrices}
          getLicensesIdsSelected={getLicensesIdsSelected}
          licenses={featuresForForm}
        />
      </SectionContainer>
      <LicensesTable
        className={Styles.table}
        registrationPricing={featurePricing.registration}
        listingPricing={featurePricing.otherFeature}
        vaultPricing={vaultPricing}
        onRegisterLicenses={registerLicenses}
      />
    </>
  )
}

export default ServiceTab
